"use client";

import React from "react";
import styles from "./styles/stem-splitter-category-item.module.scss";
import { useStemSplitterContext } from "@/components/pages/stem-splitter/components/providers/stem-splitter-provider";
import { StemSplitterCategory } from "@/data/stem-splitter-categories.constants";

type CategoryProps = {
  title: StemSplitterCategory;
};

const StemSplitterCategoryItem = ({ title }: CategoryProps) => {
  const { toggleCategory, settings } = useStemSplitterContext();

  const isSelected = settings.selectedCategories.includes(title);

  const handleClick = () => {
    toggleCategory(title);
  };
  return (
    <div
      className={`${styles.wrapper} ${isSelected ? styles.selected : ""}`}
      onClick={handleClick}
    >
      <div className={styles.text}>{title}</div>
    </div>
  );
};

export default StemSplitterCategoryItem;
